export const getBadges = (payload?: any) => ({
    type: "@saga/GET_BADGES",
    payload
});

